module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/172-st-lucia-93ad638be09d3c8bf56df09c2f3d22ce.svg";